<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <unitizacoes-data-table
          :items="unitizacoes"
          :loading="loading"
          @recharge="getUnitizacoes()"
          @switchProcessamentosExpirados="((processamentosExpirados = $event), getUnitizacoes())"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import UnitizacoesObrasService from '@/services/UnitizacoesObrasService';
  import dayjs from 'dayjs';
  import tourMixins from '@/mixins/tourMixins';
  import pusherMixins from '@/mixins/pusherMixins';

  export default {
    components: {
      UnitizacoesDataTable: () => import('@/components/unitizacoesObras/UnitizacoesDataTable')
    },
    mixins: [pusherMixins, tourMixins],

    data() {
      return {
        unitizacoes: [],
        loading: false,
        processamentosExpirados: false,
        arrTour: [
          {
            element: '#btn-nova-unitizacao',
            intro: 'Clicando neste botão você poderá criar novas unitizações de obras.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#unitizacoes-historico-search',
            intro: 'Neste campo você poderá pesquisar por unitizações de obras já existentes.',
            scrollTo: 'tooltip',
            position: 'bottom'
          },
          {
            element: '#action-download-unitizacao',
            intro: 'Clicando neste ícone você poderá fazer o download em .XLSX do resultado de sua unitização de obras.',
            scrollTo: 'tooltip',
            position: 'left'
          },
          {
            element: '#action-edit-unitizacao',
            intro: 'Clicando neste ícone você poderá editar sua unitização de obras.',
            scrollTo: 'tooltip',
            position: 'left'
          },
          {
            element: '#action-more-unitizacao',
            intro:
              'Aqui você acessa outras opções para sua unitização de obras, como ver mais detalhes, executá-la novamente ou deletá-la.',
            scrollTo: 'tooltip',
            position: 'left'
          }
        ]
      };
    },

    mounted() {
      this.getUnitizacoes();
      this.subscribe();
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('reload-pag-unitizacoes-obras', () => {
          this.getUnitizacoes();
        });
      },

      getUnitizacoes() {
        this.loading = true;
        this.unitizacoes = [];

        UnitizacoesObrasService.getUnitizacoes(this.processamentosExpirados)
          .then((response) => {
            response.data.unitizacoesObras.forEach((element) => {
              let obj = {
                id: element.id,
                nome: element.nome,
                obras: element.obras ? JSON.parse(element.obras) : [],
                data_aplicacao_modulos_aneel: element.data_aplicacao_modulos_aneel,
                qtd_minima_cabo_uar: element.qtd_minima_cabo_uar,
                unitizar_por: element.unitizar_por,
                ratear_com_ca_especifico: element.ratear_com_ca_especifico,
                status: element.status,
                data_execucao: element.data_execucao ? dayjs(element.data_execucao).format('DD/MM/YYYY HH:mm') : '-',
                usuario: element.usuario.nome,
                usuario_id: element.usuario.id
              };
              this.unitizacoes.push(obj);
            });
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar unitizações.', '', { position: 'topRight' });
          })
          .finally(() => {
            this.loading = false;
            this.iniciarTourPagina();
          });
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;

        let arrTourFormatted = this.unitizacoes.length ? this.arrTour : this.arrTour.splice(0, 2);
        this.iniciarTour(arrTourFormatted);
      }
    }
  };
</script>